
















































































import { RegularFilterValueConfig } from '@empathybroker/tsclient-play/dist/models/instance/filters/regular-filter-value-config';

import { mapActions } from 'vuex';

import { ApiEnum, GridDisplayEnum, ProductLayerEnum } from '../../enums';

import { Pagination, RegularFilter, RegularFilterSelectedValues } from '../../models';

import { SEARCH_CONSTS } from '../../store/search/search.consts';

import SearchInput from '../crud/search-input.component.vue';
import RegularFilterSelector from '../filters/regular-filter-selector.component.vue';
import { UiIconButton, UiSelect } from '../keen-ui';
import LoadingMask from '../loading-mask.component.vue';
import RankingLayer from '../product-layers/ranking-layer.component.vue';
import PaginationBar from './pagination-bar.component.vue';
import ProductItem from './product-item.component.vue';

export default {
  name: 'products-search',
  components: {
    LoadingMask,
    RankingLayer,
    PaginationBar,
    ProductItem,
    RegularFilterSelector,
    SearchInput,
    UiIconButton,
    UiSelect
  },
  props: {
    title: String,
    suggestedKeywords: Array,
    filters: Object,
    selectedProducts: Array,
    componentsVisibility: {
      type: Object,
      default: () => ({
        filters: false,
        textbox: false,
        keywords: false
      })
    },
    readonly: Boolean,
    searchParams: Object,
    searchLangs: {
      type: Array,
      default: () => []
    },
    keywordsMultipleSelection: Boolean,
    productLayer: String,
    messages: Object,
    gridItemsPerRow: Object
  },
  computed: {
    gridOptions: function () {
      return Object.keys(this.gridItemsPerRow);
    },
    productItemGridSize: function () {
      return { width: `${ 100 / this.gridItemsPerRow[this.selectedGridOption] }%` };
    },
    selectedProductLayer: function (): string {
      return {
        [ProductLayerEnum.RANKING]: 'ranking-layer',
        [ProductLayerEnum.EQUALIZE]: 'equalize-layer'
      }[this.productLayer];
    },
    searchInputLabelMessage: function (): string {
      return !!this.searchLangs.length ? this.messages.fields.search.labelFiltered : this.messages.fields.search.label;
    }
  },
  created: function () {
    this.selectedGridOption = this.gridOptions[0];
    if (!!this.searchLangs.length) {
      this.selectedSearchLang = this.searchLangs[0];
    }
  },
  data: function () {
    return {
      query: '',
      selectedKeyword: '',
      selectedSearchLang: {},
      allProductsSelected: false,
      GridDisplayEnum,
      selectedGridOption: GridDisplayEnum.BIG,
      searchResultList: [],
      pagination: {
        page: 1,
        itemsPerPage: 20,
        totalItems: 0
      },
      ProductLayerEnum,
      loading: false,
      searchTimeout: {}
    };
  },
  methods: {
    ...mapActions(SEARCH_CONSTS.moduleName, {
      search: SEARCH_CONSTS.actions.search
    }),
    setGridOptionSize: function (optionIndex: number): void {
      this.selectedGridOption = this.gridOptions[optionIndex];
    },
    isSelectedGridOption: function (optionId: GridDisplayEnum): boolean {
      return this.selectedGridOption === optionId;
    },
    onQueryChange: function (newQueryValue: string): void {
      this.query = newQueryValue;
    },
    onPaginationChange: function (pagination: Pagination): void {
      this.pagination = pagination;
      this.loadSearchData();
    },
    getProductSelectedAction: function (product) {
      const selectedProduct = (!!this.selectedProducts ? this.selectedProducts.find(productSelected =>
        (productSelected.fieldValue === product.id)) : undefined);
      return !!selectedProduct ? selectedProduct.action : undefined;
    },
    onFilterChange: function (filter: RegularFilter, selectedValues: RegularFilterSelectedValues): void {
      const itemfilterValues = selectedValues.map((selectedValue: string) => {
        const selectedValueConfig = filter.config.values.find((filterValueConfig: RegularFilterValueConfig) =>
          (filterValueConfig.id === selectedValue));
        return (selectedValueConfig.taggingId || selectedValueConfig.id);
      });
      this.$emit('changeFilter', {
        filterId: (filter.config.toolingId || filter.config.id),
        newValue: [(filter.config.multiselectDisabled ? itemfilterValues[0] : itemfilterValues)]
      });
    },
    loadSearchData: function () {
      clearTimeout(this.searchTimeout);
      this.searchTimeout = setTimeout(async () => {
        this.loading = true;
        try {
          const searchResults = await this.search({
            query: this.query,
            filters: this.filters,
            pagination: this.pagination,
            params: this.searchParams
          });
          this.searchResultList = searchResults.data.items;
          this.pagination.totalItems = searchResults.data.total;
          this.loading = false;
        } catch (error) {
          this.$emit('showError', this.$epb.utils.decodeErrorMessage(error, ApiEnum.SEARCH));
          this.loading = false;
        }
      }, 500);

    },
    getGridOptionIcon: function (optionIndex: number): string {
      return optionIndex === 0 ? 'gridsmall' : 'gridbig';
    },
    onBeforeLeave: function (el): void {
      el.style.top = `${ el.getBoundingClientRect().top }px`;
      el.style.right = `${ el.getBoundingClientRect().right }px`;
    }
  },
  watch: {
    query: async function () {
      this.pagination.page = 1;
      if (!!this.query) {
        await this.loadSearchData();
      } else {
        this.searchResultList = [];
        this.pagination.totalItems = 0;
      }
    },
    searchParams: {
      deep: true,
      handler: async function () {
        if (!!this.query) {
          await this.loadSearchData();
          this.pagination.page = 1;
        }
      }
    },
    searchLangs: function () {
      if (!!this.searchLangs.length && !this.searchLangs.some(searchLang => searchLang.value === this.selectedSearchLang.value)) {
        this.selectedSearchLang = this.searchLangs[0];
      }
    },
    selectedSearchLang: function () {
      const langFilterConfig = this.filters.lang.config;
      this.$emit('changeFilter',
        {
          filterId: (langFilterConfig.toolingId || langFilterConfig.id),
          newValue: !!this.selectedSearchLang ? [this.selectedSearchLang.value] : []
        });
    },
    filters: {
      deep: true,
      handler: async function () {
        if (!!this.query) {
          await this.loadSearchData();
          this.pagination.page = 1;
        }
      }
    }
  }
};
